/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ResponseWithErrorGeneric } from '../shared/response-with-error-generic';
import { GetAdministrativeUnitsResponseJson } from './get-administrative-units-response-json';
import { GetAdministrativeUnitsResult } from '../results/get-administrative-units-result.enum';
import { IResponseWithErrorGeneric } from '../shared/iresponse-with-error-generic.interface';
import { AdministrativeUnitDto } from '../models/administrative-unit-dto';

//<custom-head>
import { HttpResponse } from '@angular/common/http';
//</custom-head>

export class GetAdministrativeUnitsResponse extends ResponseWithErrorGeneric<GetAdministrativeUnitsResponseJson, GetAdministrativeUnitsResult> implements IResponseWithErrorGeneric<GetAdministrativeUnitsResult> {
  public administrativeUnits: AdministrativeUnitDto[];

  //<custom-body>
  constructor(response: HttpResponse<GetAdministrativeUnitsResponse>) {
    super(response, GetAdministrativeUnitsResult.Error);
    if (this.result !== GetAdministrativeUnitsResult.Success) {
      return;
    }

    if (this.body.administrativeUnits != null)
      this.administrativeUnits = this.body.administrativeUnits;
  }
  //</custom-body>
}
